import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import logoLightSvg from "../../assets/images/favicon_nakire.png";
import logoDark from "../../assets/images/logo-dark.png";
import {
  default as logo,
  default as logoLightPng,
} from "../../assets/images/logo_nakire_light.png";
// Redux Store
import {
  getSystemStatus,
  toggleRightSidebar,
  getCallbacks,
  sendCallbacks,
  getPlcStatus,
  getPlcPopupStatus,
  setPlcPopupStatus,
} from "../../store/actions";
import Loader from "../Common/Loader";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import "../../assets/css/custom.css";

class Header extends Component {
  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem("authUser"));
    this.state = {
      isSearch: false,
      user: user,
      openModal: false,
      popupVisible: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightbar = this.toggleRightbar.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.sendCallbacks = this.sendCallbacks.bind(this);
  }

  componentDidMount() {
    this.props.getSystemStatus(this.state.user);
    this.props.getCallbacks(this.state.user);
    // P01021-148: antes solo se llamaba dentro del setInterval, que no ejecuta su primera
    // vuelta hasta pasados 5s del montaje -- mientras tanto this.state.plc_status quedaba
    // undefined y el render por defecto mostraba "PLC Off" (el ternario de más abajo solo
    // pinta "On" si plc_status === "0") aunque el PLC estuviera bien. Se llama ya aquí para
    // que el primer estado real llegue lo antes posible, y el interval solo se ocupa de las
    // siguientes actualizaciones.
    this.props.getPlcStatus(this.state.user.token);
    this.props.getPlcPopupStatus(this.state.user.token);
    this.interval = setInterval(async () => {
      // Hacer llamada a la API
      await this.props.getPlcStatus(this.state.user.token);
      await this.props.getPlcPopupStatus(this.state.user.token);
    }, 5000); // Llamada a la API cada 5 segundos
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetCallbacks === false &&
      prevProps.loadingGetCallbacks === true
    ) {
      let pendingCallbacks = this.props.pendingCallbacks;
      if (pendingCallbacks) {
        this.setState({ pendingCallbacks: pendingCallbacks });
      }
    }

    if (
      this.props.loadingSendCallbacks === false &&
      prevProps.loadingSendCallbacks === true
    ) {
      let status = this.props.status;
      if (status) {
        //el estado deberia ser true
        this.setState({ status: status });
      }
    } else if (
      this.props.loadingSendCallbacks === true &&
      prevProps.loadingSendCallbacks === false
    ) {
    }

    if (
      this.props.loadingPlcStatus === false &&
      prevProps.loadingPlcStatus === true
    ) {
      let plc_status = this.props.plc_status;
      let plc_popup_status = this.props.plc_popup_status;
      if (
        plc_status &&
        plc_status === "1" &&
        plc_popup_status &&
        plc_popup_status === "0"
      ) {
        console.log("DISPLAY");
        this.setState({ plc_status: plc_status });
        this.setState({ plc_popup_status: plc_popup_status });
        this.displayPLCPopup();
      } else if (plc_status && plc_status === "0") {
        this.setState({ plc_status: plc_status });
        this.hidePLCPopup();
      } else if (
        plc_status &&
        plc_status === "1" &&
        plc_popup_status &&
        plc_popup_status === "1"
      ) {
        this.setState({ plc_status: plc_status });
        this.setState({ plc_popup_status: plc_popup_status });
        this.hidePLCPopup();
      }
    }
  }

  displayAlert() {
    this.setState({ openModal: true });
  }

  hideAlert() {
    this.setState({ openModal: false });
    document.location.reload();
  }

  hidePLCPopup() {
    this.setState({ popupVisible: false });
  }

  hidePLCPopupButton() {
    this.setState({ popupVisible: false });
    this.props.setPlcPopupStatus("1", this.state.user.token);
  }

  displayPLCPopup() {
    this.setState({ popupVisible: true });
  }

  sendCallbacks(event) {
    event.preventDefault();
    this.props.sendCallbacks(this.state.user);
    this.displayAlert();
    //aqui debera ir el popup
  }
  /**
   * Toggle sidebar
   */

  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div>
          {this.state.popupVisible && (
            <SweetAlert
              title={" DESCONEXIÓN DE PLC"}
              error={true}
              confirmBtnBsStyle="success"
              confirmBtnText={this.props.t("ok")}
              onConfirm={() => this.hidePLCPopupButton()}
            ></SweetAlert>
          )}
        </div>
        {this.state.openModal && (
          <SweetAlert
            title={
              this.props.successSendCallback ? (
                this.props.successSendCallback
              ) : (
                <span>
                  ENVIANDO CALLBACKS <Loader></Loader>
                </span>
              )
            }
            warning={this.props.status ? false : true}
            success={this.props.status === 200 ? true : false}
            error={this.props.status === 400 ? true : false}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.hideAlert()}
          ></SweetAlert>
        )}
        {this.props.loadingGetSystemStatus ? (
          <Loader></Loader>
        ) : (
          <>
            <header id="page-topbar" style={{ backgroundColor: "#FFFFFF" }}>
              <div className="navbar-header">
                <div className="d-flex">
                  <div className="navbar-brand-box">
                    {
                      <Link to="/" className="logo logo-dark">
                        <span className="logo-sm">
                          <img src={logo} alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                          <img src={logoDark} alt="" height="17" />
                        </span>
                      </Link>
                    }

                    {
                      <Link to="/" className="logo logo-light">
                        <span className="logo-sm">
                          <img src={logoLightSvg} alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                          <img src={logoLightPng} alt="" height="50" />
                        </span>
                      </Link>
                    }
                  </div>

                  <button
                    type="button"
                    onClick={this.toggleMenu}
                    className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                    id="vertical-menu-btn"
                  >
                    <i className="fa fa-fw fa-bars"></i>
                  </button>
                </div>
                <div>
                  {this.props.loadingGetCallbacks ||
                  this.props.loadingGetCallbacks ? (
                    <Loader></Loader>
                  ) : this.state.pendingCallbacks &&
                    this.state.pendingCallbacks.length >= 1 ? (
                    <button
                      type="button"
                      className="btn btn-success waves-effect waves-light boton-parpadeo"
                      onClick={(event) => this.sendCallbacks(event)}
                    >
                      <i className="bx bx-archive-out font-size-16 align-middle mr-2"></i>
                      {this.props.t("Resend Callbacks") +
                        ` (${this.state.pendingCallbacks.length})`}
                    </button>
                  ) : (
                    <span></span>
                  )}
                </div>
                <div className="d-flex">
                  <div className="dropdown d-inline-block d-lg-none ml-2">
                    <button
                      onClick={() => {
                        this.setState({ isSearch: !this.state.isSearch });
                      }}
                      type="button"
                      className="btn header-item noti-icon waves-effect"
                      id="page-header-search-dropdown"
                    >
                      <i className="mdi mdi-magnify"></i>
                    </button>
                    <div
                      className={
                        this.state.isSearch
                          ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                          : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                      }
                      aria-labelledby="page-header-search-dropdown"
                    >
                      <form className="p-3">
                        <div className="form-group m-0">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search ..."
                              aria-label="Recipient's username"
                            />
                            <div className="input-group-append">
                              <button className="btn btn-primary" type="submit">
                                <i className="mdi mdi-magnify"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="md-inline-block system-status-icon">
                    <div className="header-item ">
                      {this.state.plc_status === "0" ? (
                        <i
                          className={" mdi mdi-server-security color-success"}
                          title="PLC On"
                        ></i>
                      ) : (
                        <i
                          className=" mdi mdi-server-security color-danger"
                          title="PLC Off"
                        ></i>
                      )}
                    </div>
                  </div>
                  <ProfileMenu />
                </div>
              </div>
            </header>
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  const { loadingGetSystemStatus } = state.GetSystemStatus;
  const { loadingGetCallbacks, pendingCallbacks } = state.getCallbacks;
  const { loadingSendCallbacks, status, successSendCallback } =
    state.sendCallbacks;
  const { loadingPlcStatus, plc_status } = state.getPlcStatus;
  const { plc_popup_status } = state.getPlcPopupStatus;
  return {
    layoutType,
    loadingGetSystemStatus,
    loadingGetCallbacks,
    pendingCallbacks,
    loadingSendCallbacks,
    status,
    successSendCallback,
    loadingPlcStatus,
    plc_status,
    plc_popup_status,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    toggleRightSidebar,
    getSystemStatus,
    getCallbacks,
    sendCallbacks,
    getPlcStatus,
    getPlcPopupStatus,
    setPlcPopupStatus,
  })(withNamespaces()(Header))
);
